<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text1 animate-target" v-animate-in>Dosage (dose and interval)<sup>1</sup></div>
    <div class="ctn-text2 animate-target" v-animate-in>The recommended target dose of finerenone is 20 mg once daily.</div>
    <div class="ctn-text1 animate-target" v-animate-in>1. Measure serum potassium to determine if finerenone is appropriate<sup>1</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p4-8/4-8-1.png" />
    <div class="ctn-text3 animate-target" v-animate-in>*Finerenone may be considered with additional serum potassium monitoring within the first 4 weeks based on patient characteristics.</div>
    <div class="ctn-text1 animate-target" v-animate-in>2. Measure eGFR to determine the appropriate finerenone starting dose<sup>1</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p4-8/4-8-2.png" />
    <div class="ctn-text1 animate-target" v-animate-in>3. Continuation of treatment<sup>1</sup></div>
    <div class="ctn-text2 animate-target" v-animate-in>Four weeks after initiation or restart or up-titration of finerenone treatment,  re-measure serum potassium and eGFR. Thereafter, re-measure serum potassium periodically and as needed based on their characteristics and serum potassium levels.</div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p4-8/4-8-3.png" />
    <GoNext class="animate-target" v-animate-in href="/section4/4-9">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s4-8",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"eGFR, estimated glomerular filtration rate.<br/><br/>"
      +"Reference:<br/><div class='brs'></div>"
      +"1. KERENDIA Product Information.",
      title:"Initiation, dosing and titration"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-text1 {
  font-weight: bold;
  margin-top: 30px;
}
.ctn-text2 {
  margin-top: 20px;
}
.ctn-text3 {
  font-size: 14px;
  margin-top: 20px;
}
.ctn-image {
  width: 100%;
  margin-top: 20px;
}
</style>
